import { makeApiCall } from "../apiRequest";

export default {
  state: {
  },
  getters: {
  },
  actions: {
    async getFreeManagerActiveTemplate({ commit }) {
      const url = `employee/getManagersFreeForActiveTemplate`;
      const response = await makeApiCall(url, "GET");
      
      return response.data.data
      
    },
    async completeAssignActiveTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `assignTemplateService/todayTemplateCompleteByManager?assignTemplateId=${payload.assinTempId}&assignTemplateManagerId=${payload.tempManagerId}&managerId=${payload.managerId}`,
          `POST`
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async deleteAssignActiveTemplate({ commit }, payload) {
      try {
        const response = await makeApiCall(
          `assignTemplateService/todayTemplateDeleteByManager?assignTemplateId=${payload.assinTempId}&assignTemplateManagerId=${payload.tempManagerId}&managerId=${payload.managerId}`,
          `DELETE`
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    async addAssignActiveTemplate({ commit }, payload) {
        try {
          const response = await makeApiCall(
            `assignTemplateService/assignTodayTemplateToManagers`,
            `POST`,
            payload
          );
          return response.data;
        } catch (error) {
          console.error(error);
          throw error;
        }
      },
  },
  mutations: {
    
  },
};
